module.exports = __webpack_public_path__ + "f61398998a7c3674c80d23e1ae64fe8a.svg";